define.alias("shared/components/shared/mavely/links/select-modal", "media/components/shared/mavely/links/select-modal");